import { linkifyPhoneNumbers } from '@/utilities/linkifyPhone'

import styles from './Messagepanel.module.css'

export type MessagepanelProps = {
  title?: string
  subtitle?: string
  footer?: string
  asset?: React.ReactNode
  /** When true (AU contact page), plain-text phone numbers are rendered as clickable tel: links */
  linkifyPhones?: boolean
}

export const PhnxMessagepanel: React.FC<MessagepanelProps> = ({
  title,
  subtitle,
  footer,
  asset,
  linkifyPhones = false,
}) => {
  const renderText = (text: string) => (linkifyPhones ? linkifyPhoneNumbers(text) : text)

  return (
    <div className={styles['messagepanel']}>
      {title && <div className={styles['messageTitle']}>{renderText(title)}</div>}
      {subtitle && <div className={styles['messageSubtitle']}>{renderText(subtitle)}</div>}
      {asset && <div className={styles['messageAsset']}>{asset}</div>}
      {footer && <div className={styles['messageFooter']}>{renderText(footer)}</div>}
    </div>
  )
}
